module.exports = __webpack_public_path__ + "media/feed.299209bf.webm";